var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as classNames from "classnames";
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e.currentTarget.value);
            }
            if (_this.updateShowValidationTimer !== undefined) {
                clearTimeout(_this.updateShowValidationTimer);
            }
            if (!e.currentTarget.value) {
                _this.setState(function () { return ({ showValidationError: false }); });
            }
            else {
                _this.updateShowValidationTimer = window.setTimeout(_this.updateShowValidationError, 500);
            }
        };
        _this.updateShowValidationError = function () {
            _this.setState(function () { return ({ showValidationError: true }); });
        };
        _this.state = {};
        return _this;
    }
    Input.prototype.focus = function () {
        if (this.inputElement) {
            this.inputElement.focus();
        }
    };
    Input.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var Element = props.multiline ? "textarea" : "input";
        var additionalProps = {};
        if (props.multiline && props.rows !== undefined) {
            additionalProps = { rows: props.rows };
        }
        var isInvalid = !!props.validationErrorMessage &&
            (this.state.showValidationError || props.forceShowValidationError);
        return (React.createElement(React.Fragment, null,
            props.label ? React.createElement("label", { htmlFor: props.label }, props.label) : null,
            React.createElement("div", { className: "input-group" },
                React.createElement(Element, __assign({ ref: function (el) { return (_this.inputElement = el); }, type: "text", className: classNames("form-control", {
                        "is-invalid": isInvalid,
                        "is-loading": props.loading
                    }, props.className), readOnly: props.readonly || !props.onChange, id: props.label || undefined, placeholder: props.placeholder || props.label, autoComplete: "not-enabled", value: props.value || "", onChange: this.handleChange, onBlur: props.onBlur, disabled: props.disabled, autoFocus: props.autoFocus }, additionalProps)),
                props.children ? React.createElement("div", { className: "input-group-append" }, props.children) : null,
                isInvalid ? (React.createElement("div", { className: "invalid-feedback" }, props.validationErrorMessage)) : null)));
    };
    return Input;
}(React.Component));
export { Input };
//# sourceMappingURL=Input.js.map